import React from 'react';
import { List } from '@refinedev/mui';
import { DataGrid } from '@mui/x-data-grid';
import { ParticipantsFilters } from '@/features/participants/components';
import { useParticipantsList } from '@/features/participants/hooks';
import { useTranslation } from 'react-i18next';

export const ParticipantsList = () => {
  const { t } = useTranslation();
  const { dataGridProps, search, defaultFilters, columns } =
    useParticipantsList();

  return (
    <List title={t('pages.participants.list.title')}>
      <ParticipantsFilters onSearch={search} defaultFilters={defaultFilters} />
      <DataGrid
        {...dataGridProps}
        columns={columns}
        pageSizeOptions={[10, 25, 50]}
        disableRowSelectionOnClick
        disableColumnFilter
      />
    </List>
  );
};
